import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A] text-[#FAF9F6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col items-center text-center mb-16 md:mb-20 pb-12 md:pb-16 border-b border-[#FAF9F6]/10">
          <img
            src="/logo.png"
            alt="Haven and Hue logo"
            data-testid="footer-logo"
            className="h-16 md:h-20 w-auto object-contain grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-[filter,opacity] duration-500"
          />
          <p className="mt-6 max-w-md text-sm md:text-base text-[#FAF9F6]/70 leading-relaxed">
            Bespoke, turnkey interior design &amp; interior decor for premium residences across Noida &amp; Delhi NCR.
          </p>
        </div>
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="overline text-[#C5A880] mb-6">Est. Noida &mdash; Delhi NCR</div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] max-w-xl">
              Let&rsquo;s engineer your next space.
            </h2>
            <Link
              to="/consultation"
              data-testid="footer-cta"
              className="inline-flex items-center gap-3 mt-10 text-[#C5A880] border-b border-[#C5A880]/40 pb-1 hover:border-[#C5A880] transition-colors duration-300 group"
            >
              <span className="text-lg">Request a Consultation</span>
              <ArrowUpRight size={20} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <div className="overline text-[#FAF9F6]/40 mb-6">Studio</div>
            <ul className="space-y-4 text-sm text-[#FAF9F6]/85">
              <li className="flex gap-3"><Phone size={16} className="text-[#C5A880] mt-0.5 shrink-0" />
                <span>{BRAND.phones.join(" · ")}</span>
              </li>
              <li className="flex gap-3"><Mail size={16} className="text-[#C5A880] mt-0.5 shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#C5A880] transition-colors duration-300 break-all">{BRAND.email}</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#FAF9F6]/40 mb-6">Locations</div>
            <ul className="space-y-4 text-sm text-[#FAF9F6]/85">
              {BRAND.locations.map((loc) => (
                <li key={loc} className="flex gap-3">
                  <MapPin size={16} className="text-[#C5A880] mt-0.5 shrink-0" />
                  <span>{loc}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#FAF9F6]/10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex flex-wrap items-center gap-6">
            {BRAND.socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="text-sm text-[#FAF9F6]/70 hover:text-[#C5A880] transition-colors duration-300"
              >
                {s.label}
              </a>
            ))}
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 text-xs text-[#FAF9F6]/50">
            <span>&copy; {new Date().getFullYear()} Haven &amp; Hue. Bespoke Interior Design Studio.</span>
            <span className="overline text-[#C5A880]/70">The Art of Space. Engineered.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
